// A customer's statement as a PDF (receivables.statementPdf), downloaded as "<name> - <file>": Receivables'
// Statement, in both designs.
import { client } from '../api.ts';
import { todayIn } from './model.ts';
import { errorText } from './ui.tsx';

function download(name: string, base64: string, type: string) {
  const bytes = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  const url = URL.createObjectURL(new Blob([bytes], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** The customer's statement to today, downloaded; a refusal is said in the toast. */
export async function downloadStatement(customerId: string, name: string, toast: (m: string) => void) {
  try {
    const pdf = await client.call<{ filename: string; base64: string; contentType: string }>(
      'receivables.statementPdf',
      { customerId, to: todayIn() },
    );
    download(`${name} - ${pdf.filename}`, pdf.base64, pdf.contentType);
  } catch (e) {
    toast(errorText(e));
  }
}
